const beepFrequencyHertz = 880;
const beepDurationSeconds = 0.25;
const beepVolume = 0.2;

/**
 * Plays a short beep. Browsers may block audio until the user has interacted
 * with the page, in which case the sound is skipped silently.
 */
export const playAlertSound = () => {
    try {
        const AudioContextClass =
            window.AudioContext ||
            (window as unknown as { webkitAudioContext?: typeof AudioContext })
                .webkitAudioContext;
        if (!AudioContextClass) {
            return;
        }
        const audioContext = new AudioContextClass();
        const oscillator = audioContext.createOscillator();
        const gain = audioContext.createGain();
        oscillator.frequency.value = beepFrequencyHertz;
        gain.gain.value = beepVolume;
        oscillator.connect(gain);
        gain.connect(audioContext.destination);
        oscillator.onended = () => {
            void audioContext.close();
        };
        oscillator.start();
        oscillator.stop(audioContext.currentTime + beepDurationSeconds);
    } catch (error) {
        console.warn('Could not play the alert sound:', error);
    }
};
